import moment from "moment";

export type AuditDashboardInventoryMetric =
  | "opening"
  | "activated"
  | "closing"
  | "moved_to_backstock"
  | "counter_sold_out"
  | "backstock_opening"
  | "backstock_activated_to_backstock"
  | "backstock_moved_from_counter"
  | "backstock_returned_to_counter"
  | "backstock_returned_to_lottery"
  | "backstock_inventory_depletion"
  | "backstock_closing"
  | "vending_opening"
  | "vending_activated"
  | "vending_moved"
  | "vending_sold_out"
  | "vending_closing";

export interface AuditDashboardCurrentInventoryStatusParams {
  metric: AuditDashboardInventoryMetric;
  reportDate?: string;
  startDate?: string;
  endDate?: string;
}

export const buildAuditDashboardCurrentInventoryStatusPath = (
  storeId: string,
  params: AuditDashboardCurrentInventoryStatusParams
) => {
  const searchParams = new URLSearchParams();
  searchParams.set("metric", params.metric);
  if (params.reportDate) {
    searchParams.set("report_date", moment(params.reportDate).format("YYYY-MM-DD"));
  }
  if (params.startDate) {
    searchParams.set("start_date", moment(params.startDate).format("YYYY-MM-DD"));
  }
  if (params.endDate) {
    searchParams.set("end_date", moment(params.endDate).format("YYYY-MM-DD"));
  }

  return `/store/${storeId}/scratchers/current-inventory-status?${searchParams.toString()}`;
};

export const buildBackstockAuditDuePath = (storeId: string) => {
  const searchParams = new URLSearchParams();
  searchParams.set("subgroup", "Backstock");
  searchParams.set("sort", "subgroup");
  searchParams.set("sort_direction", "asc");

  return `/store/${storeId}/scratchers/current-inventory-status?${searchParams.toString()}`;
};
